export default "__VITE_ASSET__DF3_0aX2__"